import basic from 'Assets/img/svg/membership/basicBG.svg';
import premium from 'Assets/img/svg/membership/premiumBG.svg';

export const typesOfMembership = [
	{
		id: 1,
		description: `Basic Membership allows you to track {NAME}'s milestones allowing for recommended exercises to be customized to {NAME}'s developmental needs.`,
		type: 'Basic Membership',
		total: '$24',
		time:' per year',
		info: 'JOIN',
		bg: basic,
		link: '/payment-information',
	},
	{
		id: 2,
		description: `Premium Membership allows you to track {NAME}'s milestones, as well as receive a monthly selection of tools and skills-based toys tailored to {NAME}'s unique developmental profile.`,
		type: 'Premium Membership',
		total: '$60',
		time: ' per month',
		info: 'JOIN',
		bg: premium,
		link: '/premium-payment',
	},
];
export const information = {
	cards: {
		heading: 'Congratulations!',
		subheading: 'We are glad you are here!',
		info: `
You have made an excellent choice. The first step to helping {NAME} is to understand
where {he/she} is developmentally. The Milestone page will provide you with a list of
developmental skills that present around your {NAME}'s age. By noting that a
skill has been mastered and when it was mastered, we can determine if {NAME} has
developmental lags; is on-track or advanced, as well as showing signs of asynchronous development.
We will use this information to suggest meaningful exercises that meets {NAME} where
{he/she} is developmentally and escort {him/her} to the next stage of development. Let's
begin by going to the Milestones page to log which milestones {NAME} has achieved.`,
	},
	payment: {
		heading: `{NAME}'s Membership`,
		subheading: 'Please enter your payment information below.',
		info: `
		PLEASE NOTE: Basic Memberships are billed annually. To activate this membership, you must pay for a year in advance. Then you can relax and rest assured that you will be able to continue to track {NAME}'s milestones for and entire year. If you need to cancel your membership, you may do so at any time. You will be refunded $2 for each month remaining on your annual membership.`,
	},
	premium:{
		info:`PLEASE NOTE: Premium Memberships are billed monthly. Your Membership will automatically renew on the same day of the month that you joined. If you wish to cancel, you may do so at any time. In order for you not to be billed for the following month, please cancel when you receive the questionnaire regarding {NAME}’s experience with the toy. Once the next toy has been shipped, payment will not longer be able to be canceled for that month. Cancellation will go into effect for the next month.`
	},
	checkout: {
		heading: 'Cries to get needs met',
		subheading: '',
		info: `
{NAME} cries in order to let you know that something
 is not right.  [he/she] is hungry, tired, or uncomfortable. 
[he/she] is using one cry for everything right now.
`,
	},
	timeline: {
		copy: `Set 12 sensory beads that have
been screwed together to form
a complete bead in front of
 {NAME}.`,
		proTip: `Watch {NAME} as [he/she] does this activity. Follow [his/her] lead. If the first time you
					introduce this activity,{NAME} only wants to put the beads in [his/her] mouth, then that is
					fine. After a few minutes of oral exploration, hand {NAME} a different bead that has a
					different texture to explore. The next time that you do this activity, start with snapping two beads
					together and see what {NAME} does. The snapping of the beads together will take a lot of
					practice to master. It is possible that {NAME} will not master it for another month or two.
					This is normal. Continuing this activity over the course of several months will assure success.`,
	},
};
